import io from 'socket.io-client';

export const FJSOCKET_STATUS = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    ERROR: 'error',
    CONNECTING: 'connecting',
};

class FJWebSocket {
    _socket = null;
    _status = FJSOCKET_STATUS.DISCONNECTED;
    _ident = null;

    constructor(props) {
        props = props || {};

        const { url, connectId } = props;
        this._ident = connectId;

        this._socket = io(url, {
            reconnectionAttempts: 3,
            autoConnect: false,
        });
    }

    async connect() {
        if (!this._socket) {
            return Promise.reject(new Error('Socket is not initialized'));
        }

        return new Promise((resolve, reject) => {
            if (this._status === FJSOCKET_STATUS.CONNECTED) {
                return resolve();
            }

            const onConnect = () => {
                console.log('connect');
                this._status = FJSOCKET_STATUS.CONNECTED;
                this._socket.emit('binding', this._ident);
                this._socket.off('connect', onConnect);
                resolve();
            };

            const onError = error => {
                console.log('error', error);
                this._status = FJSOCKET_STATUS.ERROR;
                this._socket.off('error', onError);
                reject(error);
            };

            const onConnectError = error => {
                console.log('connect_error', error);
                this._status = FJSOCKET_STATUS.ERROR;
                this._socket.off('connect_error', onConnectError);
                reject(error);
            };

            this._socket.on('connect', onConnect);
            this._socket.on('error', onError);
            this._socket.on('connect_error', onConnectError);

            this._status = FJSOCKET_STATUS.CONNECTING;
            this._socket.connect();
        });
    }

    close() {
        if (this._status !== FJSOCKET_STATUS.CONNECTED) {
            return;
        }

        this._socket.disconnect();
        this._status = FJSOCKET_STATUS.DISCONNECTED;
    }

    bindEvents() {}

    get status() {
        return this._status;
    }

    get ident() {
        return this._ident;
    }
}

export default FJWebSocket;
